import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { RacemapStarter } from '@racemap/utilities/types/events';
import type { ObjectId } from 'bson';
import useSWR, { type SWRConfiguration } from 'swr';
import { apiClient } from '.';

/**
 * Returns the starters of an event
 *
 * @returns {starters: Array<RacemapStarter> | null | undefined, isLoading: boolean, error: Error, mutate: () => void}
 */
export function useEventStarters(
  {
    ids,
    eventId,
    filter,
    deviceId,
  }: {
    ids?: Array<string>;
    eventId?: string | ObjectId;
    filter?: Array<string>;
    deviceId?: string;
  },
  options?: SWRConfiguration,
): {
  starters: Array<RacemapStarter> | null | undefined;
  isLoading: boolean;
  error: Error;
  mutate: () => void;
} {
  const { data, isLoading, error, mutate } = useSWR(
    eventId != null
      ? [
          'GET',
          'STARTERS',
          ids ? ids.join(',') : '',
          eventId,
          filter?.join(',') ?? '',
          deviceId ?? '',
        ]
      : null,
    async ([, , idsStr, eventId, filterStr, deviceId]) => {
      const idsArray = idsStr ? idsStr.split(',') : [];
      const filters = filterStr ? filterStr.split(',') : [];
      const event = await apiClient.getEventStarters(eventId.toString(), {
        filter: filters,
        ids: idsArray,
        deviceId: deviceId || undefined,
      });
      return event;
    },
    {
      revalidateIfStale: false,
      refreshInterval: OneMinuteInMillis * 1,
      keepPreviousData: true,
      ...options,
    },
  );

  return { starters: data, isLoading, error, mutate };
}
